import { ReactNodeViewRenderer } from "@tiptap/react";
import { Node, mergeAttributes } from "@tiptap/core";
import LineReference from "./LineReference";

const LineReferenceExtention = Node.create({
	name: "lineReference",
	group: "inline",
	inline: true,
	atom: true,
	draggable: true,

	addAttributes() {
		return {
			content: {
				default: "",
				parseHTML: (element) => element.getAttribute("data-content") || "",
				renderHTML: (attributes) => ({
					"data-content": attributes.content,
				}),
			},
			documentName: {
				default: "",
				parseHTML: (element) => element.getAttribute("data-document-name") || "",
				renderHTML: (attributes) => ({
					"data-document-name": attributes.documentName,
				}),
			},
			documentId: {
				default: 0,
				parseHTML: (element) => {
					const id = element.getAttribute("data-document-id");
					return id ? parseInt(id, 10) : 0;
				},
				renderHTML: (attributes) => ({
					"data-document-id": attributes.documentId,
				}),
			},
			itemId: {
				default: "",
				parseHTML: (element) => element.getAttribute("data-item-id") || "",
				renderHTML: (attributes) => ({
					"data-item-id": attributes.itemId,
				}),
			},
			refType: {
				default: "",
				parseHTML: (element) => element.getAttribute("data-ref-type") || "",
				renderHTML: (attributes) => ({
					"data-ref-type": attributes.refType,
				}),
			},
		};
	},

	parseHTML() {
		return [{ tag: "line-reference" }];
	},

	renderHTML({ HTMLAttributes }) {
		return ["line-reference", mergeAttributes(HTMLAttributes)];
	},

	addNodeView() {
		return ReactNodeViewRenderer(LineReference, {
			contentDOMElementTag: "div",
		});
	},
});

export default LineReferenceExtention;
